<template>
    <div class="wtw-container full-max-width-minus-two colors-container">
        <div class="row clearfix" v-for="i in rowCount">
            <div class="color-option"
                 v-for="(option, index) in optionCountInRow(i)"
                 @click.stop="toggleOption(option.product_option_value_id)"
                 :class="{active: optionActive(option.product_option_value_id) || allActive, clearfix: (index + 1) % 3 == 0}"
            >
                <img :src="option.product_option_value_image_url"/>
                <div class="cross"></div>
                <div class="color-option-text">
                    {{ option.product_option_value_title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default{
        data() {
            return {
                optionValues: [],
                itemsPerRow: 3,
                allActive: false
            }
        },
        computed: {
            rowCount(){
                return this.options && Math.ceil(this.options.length / this.itemsPerRow);
            },
            anyOptionsActive(){
                return this.optionValues.length;
            }
        },
        created(){
            if(this.optionsSelected) {
                this.optionValues = this.optionsSelected;
            }
        },
        props: ['options', 'sendOptions', 'optionsAll', 'optionsSelected'],
        methods: {
            toggleOption(optionValue){
                let index = this.optionIndex(optionValue);
                if (index !== -1) {
                    this.optionValues.splice(index, 1);
                } else {
                    this.optionValues.push(optionValue);
                }
            },
            optionIndex(optionValue){
                return this.optionValues.indexOf(optionValue);
            },
            optionActive(optionValue){
                return this.optionIndex(optionValue) !== -1;
            },
            optionCountInRow(index){
                return this.options.slice((index - 1) * this.itemsPerRow, index * this.itemsPerRow)
            }
        },
        watch: {
            sendOptions: function () {
                if (this.sendOptions) {
                    let optionIds = this.options.map((option) => {
                        return option.product_option_value_id;
                    });
                    // prevent duplicates in selected array
                    this.$parent.$emit('removeOptions', optionIds)
                    this.$parent.$emit('optionsSending', this.optionValues, true);
                }
            }
        },
        mounted(){
            /* preload all colors into option values */
            if(!this.optionsSelected) {
                this.optionValues = this.options.map(option => option['product_option_value_id']);
            }
        },
    }
</script>